/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimPropertiesResponse,
  ContactPropertyLink,
  CreatePropertyRequest,
  GetPropertyContacts200Response,
  GetPropertyOrganizations200Response,
  LinkPropertyContactRequest,
  LinkPropertyOrganizationRequest,
  ListPropertiesResponse,
  Problem,
  Property,
  UpdatePropertyRequest,
} from '../models/index';
import {
    ClaimPropertiesResponseFromJSON,
    ClaimPropertiesResponseToJSON,
    ContactPropertyLinkFromJSON,
    ContactPropertyLinkToJSON,
    CreatePropertyRequestFromJSON,
    CreatePropertyRequestToJSON,
    GetPropertyContacts200ResponseFromJSON,
    GetPropertyContacts200ResponseToJSON,
    GetPropertyOrganizations200ResponseFromJSON,
    GetPropertyOrganizations200ResponseToJSON,
    LinkPropertyContactRequestFromJSON,
    LinkPropertyContactRequestToJSON,
    LinkPropertyOrganizationRequestFromJSON,
    LinkPropertyOrganizationRequestToJSON,
    ListPropertiesResponseFromJSON,
    ListPropertiesResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    PropertyFromJSON,
    PropertyToJSON,
    UpdatePropertyRequestFromJSON,
    UpdatePropertyRequestToJSON,
} from '../models/index';

export interface CreatePropertyOperationRequest {
    createPropertyRequest: CreatePropertyRequest;
}

export interface DeletePropertyRequest {
    id: number;
}

export interface GetPropertyRequest {
    id: number;
}

export interface GetPropertyClaimsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface GetPropertyContactsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface GetPropertyOrganizationsRequest {
    id: number;
    limit?: number;
    offset?: number;
}

export interface LinkPropertyContactOperationRequest {
    id: number;
    linkPropertyContactRequest: LinkPropertyContactRequest;
}

export interface LinkPropertyOrganizationOperationRequest {
    id: number;
    linkPropertyOrganizationRequest: LinkPropertyOrganizationRequest;
}

export interface ListPropertiesRequest {
    search?: string;
    limit?: number;
    offset?: number;
}

export interface UnlinkPropertyContactRequest {
    id: number;
    contactId: number;
    addressType?: string;
}

export interface UnlinkPropertyOrganizationRequest {
    id: number;
    organizationId: number;
}

export interface UpdatePropertyOperationRequest {
    id: number;
    updatePropertyRequest: UpdatePropertyRequest;
}

/**
 * PropertiesApi - interface
 * 
 * @export
 * @interface PropertiesApiInterface
 */
export interface PropertiesApiInterface {
    /**
     * 
     * @summary Create a property
     * @param {CreatePropertyRequest} createPropertyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    createPropertyRaw(requestParameters: CreatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>>;

    /**
     * Create a property
     */
    createProperty(requestParameters: CreatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property>;

    /**
     * 
     * @summary Delete a property
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    deletePropertyRaw(requestParameters: DeletePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a property
     */
    deleteProperty(requestParameters: DeletePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get property by ID
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    getPropertyRaw(requestParameters: GetPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>>;

    /**
     * Get property by ID
     */
    getProperty(requestParameters: GetPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property>;

    /**
     * 
     * @summary Get all claims linked to a property
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    getPropertyClaimsRaw(requestParameters: GetPropertyClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPropertiesResponse>>;

    /**
     * Get all claims linked to a property
     */
    getPropertyClaims(requestParameters: GetPropertyClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPropertiesResponse>;

    /**
     * 
     * @summary List contacts linked to a property
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    getPropertyContactsRaw(requestParameters: GetPropertyContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPropertyContacts200Response>>;

    /**
     * List contacts linked to a property
     */
    getPropertyContacts(requestParameters: GetPropertyContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPropertyContacts200Response>;

    /**
     * 
     * @summary List organizations linked to a property
     * @param {number} id 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    getPropertyOrganizationsRaw(requestParameters: GetPropertyOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPropertyOrganizations200Response>>;

    /**
     * List organizations linked to a property
     */
    getPropertyOrganizations(requestParameters: GetPropertyOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPropertyOrganizations200Response>;

    /**
     * 
     * @summary Link a contact to a property
     * @param {number} id 
     * @param {LinkPropertyContactRequest} linkPropertyContactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    linkPropertyContactRaw(requestParameters: LinkPropertyContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactPropertyLink>>;

    /**
     * Link a contact to a property
     */
    linkPropertyContact(requestParameters: LinkPropertyContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactPropertyLink>;

    /**
     * 
     * @summary Link an organization to a property
     * @param {number} id 
     * @param {LinkPropertyOrganizationRequest} linkPropertyOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    linkPropertyOrganizationRaw(requestParameters: LinkPropertyOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Link an organization to a property
     */
    linkPropertyOrganization(requestParameters: LinkPropertyOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * 
     * @summary List properties
     * @param {string} [search] Search by address
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    listPropertiesRaw(requestParameters: ListPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPropertiesResponse>>;

    /**
     * List properties
     */
    listProperties(requestParameters: ListPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPropertiesResponse>;

    /**
     * When addressType query param is provided, only the specific link with that address type is removed. When omitted, all links between the contact and property are removed. 
     * @summary Unlink a contact from a property
     * @param {number} id 
     * @param {number} contactId 
     * @param {string} [addressType] When provided, only removes the link with the specified address type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    unlinkPropertyContactRaw(requestParameters: UnlinkPropertyContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * When addressType query param is provided, only the specific link with that address type is removed. When omitted, all links between the contact and property are removed. 
     * Unlink a contact from a property
     */
    unlinkPropertyContact(requestParameters: UnlinkPropertyContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlink an organization from a property
     * @param {number} id 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    unlinkPropertyOrganizationRaw(requestParameters: UnlinkPropertyOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink an organization from a property
     */
    unlinkPropertyOrganization(requestParameters: UnlinkPropertyOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update a property
     * @param {number} id 
     * @param {UpdatePropertyRequest} updatePropertyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropertiesApiInterface
     */
    updatePropertyRaw(requestParameters: UpdatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>>;

    /**
     * Update a property
     */
    updateProperty(requestParameters: UpdatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property>;

}

/**
 * 
 */
export class PropertiesApi extends runtime.BaseAPI implements PropertiesApiInterface {

    /**
     * Create a property
     */
    async createPropertyRaw(requestParameters: CreatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>> {
        if (requestParameters['createPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'createPropertyRequest',
                'Required parameter "createPropertyRequest" was null or undefined when calling createProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePropertyRequestToJSON(requestParameters['createPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyFromJSON(jsonValue));
    }

    /**
     * Create a property
     */
    async createProperty(requestParameters: CreatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property> {
        const response = await this.createPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a property
     */
    async deletePropertyRaw(requestParameters: DeletePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a property
     */
    async deleteProperty(requestParameters: DeletePropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePropertyRaw(requestParameters, initOverrides);
    }

    /**
     * Get property by ID
     */
    async getPropertyRaw(requestParameters: GetPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyFromJSON(jsonValue));
    }

    /**
     * Get property by ID
     */
    async getProperty(requestParameters: GetPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property> {
        const response = await this.getPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all claims linked to a property
     */
    async getPropertyClaimsRaw(requestParameters: GetPropertyClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPropertiesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPropertyClaims().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/claims`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPropertiesResponseFromJSON(jsonValue));
    }

    /**
     * Get all claims linked to a property
     */
    async getPropertyClaims(requestParameters: GetPropertyClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPropertiesResponse> {
        const response = await this.getPropertyClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List contacts linked to a property
     */
    async getPropertyContactsRaw(requestParameters: GetPropertyContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPropertyContacts200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPropertyContacts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/contacts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPropertyContacts200ResponseFromJSON(jsonValue));
    }

    /**
     * List contacts linked to a property
     */
    async getPropertyContacts(requestParameters: GetPropertyContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPropertyContacts200Response> {
        const response = await this.getPropertyContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List organizations linked to a property
     */
    async getPropertyOrganizationsRaw(requestParameters: GetPropertyOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPropertyOrganizations200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPropertyOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/organizations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPropertyOrganizations200ResponseFromJSON(jsonValue));
    }

    /**
     * List organizations linked to a property
     */
    async getPropertyOrganizations(requestParameters: GetPropertyOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPropertyOrganizations200Response> {
        const response = await this.getPropertyOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a contact to a property
     */
    async linkPropertyContactRaw(requestParameters: LinkPropertyContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactPropertyLink>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkPropertyContact().'
            );
        }

        if (requestParameters['linkPropertyContactRequest'] == null) {
            throw new runtime.RequiredError(
                'linkPropertyContactRequest',
                'Required parameter "linkPropertyContactRequest" was null or undefined when calling linkPropertyContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/contacts`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkPropertyContactRequestToJSON(requestParameters['linkPropertyContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactPropertyLinkFromJSON(jsonValue));
    }

    /**
     * Link a contact to a property
     */
    async linkPropertyContact(requestParameters: LinkPropertyContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactPropertyLink> {
        const response = await this.linkPropertyContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link an organization to a property
     */
    async linkPropertyOrganizationRaw(requestParameters: LinkPropertyOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling linkPropertyOrganization().'
            );
        }

        if (requestParameters['linkPropertyOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'linkPropertyOrganizationRequest',
                'Required parameter "linkPropertyOrganizationRequest" was null or undefined when calling linkPropertyOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/organizations`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkPropertyOrganizationRequestToJSON(requestParameters['linkPropertyOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Link an organization to a property
     */
    async linkPropertyOrganization(requestParameters: LinkPropertyOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.linkPropertyOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List properties
     */
    async listPropertiesRaw(requestParameters: ListPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPropertiesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPropertiesResponseFromJSON(jsonValue));
    }

    /**
     * List properties
     */
    async listProperties(requestParameters: ListPropertiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPropertiesResponse> {
        const response = await this.listPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * When addressType query param is provided, only the specific link with that address type is removed. When omitted, all links between the contact and property are removed. 
     * Unlink a contact from a property
     */
    async unlinkPropertyContactRaw(requestParameters: UnlinkPropertyContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unlinkPropertyContact().'
            );
        }

        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling unlinkPropertyContact().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['addressType'] != null) {
            queryParameters['addressType'] = requestParameters['addressType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/contacts/{contactId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * When addressType query param is provided, only the specific link with that address type is removed. When omitted, all links between the contact and property are removed. 
     * Unlink a contact from a property
     */
    async unlinkPropertyContact(requestParameters: UnlinkPropertyContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkPropertyContactRaw(requestParameters, initOverrides);
    }

    /**
     * Unlink an organization from a property
     */
    async unlinkPropertyOrganizationRaw(requestParameters: UnlinkPropertyOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unlinkPropertyOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling unlinkPropertyOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}/organizations/{organizationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink an organization from a property
     */
    async unlinkPropertyOrganization(requestParameters: UnlinkPropertyOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkPropertyOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * Update a property
     */
    async updatePropertyRaw(requestParameters: UpdatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProperty().'
            );
        }

        if (requestParameters['updatePropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePropertyRequest',
                'Required parameter "updatePropertyRequest" was null or undefined when calling updateProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/properties/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePropertyRequestToJSON(requestParameters['updatePropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyFromJSON(jsonValue));
    }

    /**
     * Update a property
     */
    async updateProperty(requestParameters: UpdatePropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property> {
        const response = await this.updatePropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
